
<section class="bg-half-170 bg-light d-table w-100" id="home" style="background: url('assets/images/blog/breadcrumb.png');">
    <div class="container">
        <div class="row mt-5 justify-content-center">
            <!-- <div class="col-lg-12 text-center">
                <div class="pages-heading">
                      <h2> {{currentLang === 'ar' ? blog.TiteleAr : blog.TiteleEn }}  </h2>
          <ul class="list-unstyled mt-4 mb-0">
            <li class="list-inline-item h6 date text-muted"><i class="mdi mdi-calendar-check"></i> {{blog.createDate | date : 'dd/MM/yyyy'}} </li>
          </ul>
                </div>
            </div>  -->
        </div><!--end row-->
  <div class="position-breadcrumb">
      <nav aria-label="breadcrumb" class="d-inline-block">
        <ul class="breadcrumb rounded shadow mb-0 px-4 py-2">
          <li class="breadcrumb-item"><a routerLink="/">{{'Home' | translate}}</a></li>
          <li class="breadcrumb-item active" aria-current="page">{{'Projects' | translate}}</li>
        </ul>
      </nav>
    </div>
    
    </div> <!--end container-->
</section><!--end section-->
<!-- Shape Start -->
<div class="position-relative">
    <div class="shape overflow-hidden text-color-white">
        <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
        </svg>
    </div>
</div>
<!--Shape End-->

<!-- Job List Start -->
<section class="section">
 

    <div class="container mt-5 mt-sm-0">
     
<div class="row">
        <div class="col-md-6 col-lg-4 mt-4 pt-2" *ngFor="let project of ourprojects; let i = index">

          <div class="showcase-card animate-card" [style.animation-delay]="(i * 0.12) + 's'">

            <a routerLink="/project-details/{{project.Id}}" class="showcase-link">

              <div class="showcase-media">
                <img *ngIf="project && project.Images && project.Images[0]?.ImageUrl"
                     [src]="project.Images[0]?.ImageUrl"
                     class="showcase-img"
                     alt="">
                <div class="showcase-gradient"></div>

                <span class="showcase-view-btn">
                  {{'View Project' | translate}}
                  <i-feather name="arrow-up-right" class="icons"></i-feather>
                </span>
              </div>

              <div class="showcase-content">
                <span class="showcase-tag">{{'Project' | translate}}</span>
                <h5 class="showcase-title">
                  {{currentLang === 'ar' ? project.TitleAr : project.TitleEn}}
                </h5>
                <p class="showcase-subtitle">
                  {{currentLang === 'ar' ? project.SubTitleAr : project.SubTitleEn}}
                </p>
              </div>
            </a>

            <button type="button" class="showcase-bookmark" (click)="$event.stopPropagation()">
              <i class="uil uil-bookmark align-middle"></i>
            </button>

          </div>

        </div>

      </div>
    </div><!--end container-->
</section><!--end section-->
<!-- Job List End -->

<!-- Back to top -->
<a href="javascript: void(0);" class="btn btn-icon btn-primary back-to-top" id="back-to-top" [ngxScrollTo]="'#home'">
    <i-feather name="arrow-up" class="icons"></i-feather>
</a>
<!-- Back to top -->